import clsx from "clsx";

interface Props {
  label: React.ReactNode;
  name?: string;
  focussed?: boolean;
  error?: boolean;
  required?: boolean;
  tags?: React.ReactNode | React.ReactNode[];
}

const FieldLabel = ({
  label,
  name,
  focussed,
  error,
  required,
  tags,
}: Props) => {
  return (
    <label
      htmlFor={name}
      className={clsx(
        error
          ? "text-error-dark"
          : focussed
          ? "text-primary-main"
          : "text-gray-900"
      )}
    >
      {label} {required && "*"} {tags && tags}
    </label>
  );
};

export default FieldLabel;
